<template>
  <div class="container">
    <!-- 头部 -->
    <headerTemplate></headerTemplate>

    <router-view />
    <!-- 底部 -->
    <footer-template></footer-template>
  </div>
</template>

<script>
import footerTemplate from './template/footer-template'
import headerTemplate from './template/header-template'
export default {
  name: 'home',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  components: {
    headerTemplate,
    footerTemplate
  }
}
</script>

<style scoped lang="less">
  @import '../assets/style/index.less';
</style>



// WEBPACK FOOTER //
// src/components/main.vue